import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AlertCircle, X } from 'lucide-react'
import { useDeviceContext } from '@/hooks/learner/useDeviceContext'
import { shouldShowBanner } from '@/components/learner/profile/lib/shouldShowBanner'

const STORAGE_KEY = 'unreg-banner-dismissed'

export function UnregisteredDeviceBanner() {
  const { t } = useTranslation('learner')
  const deviceContext = useDeviceContext()
  const [dismissed, setDismissed] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return sessionStorage.getItem(STORAGE_KEY) === '1'
  })

  const visible = shouldShowBanner(deviceContext, dismissed)
  if (!visible) return null

  const onDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1')
    setDismissed(true)
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-[72px] left-0 right-0 z-30 flex h-10 items-center justify-center gap-2.5 bg-lc-bg-overlay px-12"
    >
      <AlertCircle className="size-5 shrink-0 fill-lc-error-500 text-lc-text-inverse" aria-hidden />
      <p className="text-lc-v3-body-1 font-medium text-lc-text-inverse">
        {t('device.unregistered.banner')}
      </p>
      <button
        type="button"
        onClick={onDismiss}
        aria-label={t('device.unregistered.dismiss')}
        className="absolute right-4 inline-flex size-6 shrink-0 items-center justify-center rounded-full text-lc-text-inverse hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lc-key-500 md:right-10"
      >
        <X className="size-4" />
      </button>
    </div>
  )
}
